import { useState } from 'react'
import cookie from 'cookie'
import { login } from 'shared/api'
import useAsyncEffect from 'shared/hooks/use-async-effect'

const useCSRFToken = () => {
    const [CSRFToken, setCSRFToken] = useState<string | undefined | null>()

    useAsyncEffect(async () => {
        await login()
        setCSRFToken(cookie.parse(document.cookie).csrftoken)
    }, [])

    return {
        CSRFToken,
    }
}

export default useCSRFToken
